import React, { useMemo, useEffect, useState, useContext } from "react";
import {
  DataGrid,
  GridColDef,
  GridPreProcessEditCellProps,
} from "@mui/x-data-grid";
import { Box, Button, Autocomplete, TextField } from "@mui/material";

import { grossDemandActions } from "../service/grossdemand.actions";
import { GrossDemandDetermination } from "../service/update";

import FleetPlanningToolbar from "./planning/FleetPlanningToolbar";
import FleetPlanningFooter from "./planning/FleetPlanningFooter";

import * as Mui from "@mui/material";

import Loading from "./common/Loading";
import PopupMessage from "./common/PopupMessage";
import "../component/grossDemandDetermination.css";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../util/state/globalAction";
import { snackbarTypes } from "../../../util/state/globalVariables";
import CustomLoader from "../../../util/component/CustomLoader";
import GenericFilterBox from "./common/GenericFilterBox";
import { ContextOperation } from "../context/OperationContext";
import useSnackbar from "../hooks/useSnackbar";
import { useHasScope } from "../../../config/globalConfig";
import { Tooltip } from "@mui/material";

// interface Props {
//   props.tenant?:string;
//   aggregations?:string
// }
const GrossDemandDeterminationTable = (props: any) => {
  const hasScope = useHasScope;
  const totalDemandUpper = "TOTAL DEMAND";
  const totalDemand = "Total Demand";
  const userDemand = grossDemandActions();
  const { t } = useTranslation(["operation"]);
  const { dispatchGlobalData } = useContext(GlobalContext);
  const [rows, setRows] = useState<any>([]);
  const [isFrozenYear, setIsFrozenYear] = React.useState<boolean>(false);
  const [mappaResp, setMappaResp] = useState<any>();
  const [loading, setIsLoading] = useState(false);
  const [popupSeverity, setPopupSeverity] = React.useState<string>();
  const [popupMessage, setPopupMessage] = useState<string>();
  const [showPopup, setShowPopup] = React.useState<boolean>(false);
  const [year, setYear] = useState(new Date().getFullYear());
  const { tenant } = useContext(ContextOperation);
  const [exportUrl, setExportUrl] = React.useState<string>(
    "grossdemanddetermination/excel"
  );
  const [tableData, setTableData] = React.useState<GrossDemandDetermination>(
    {}
  );
  //const [refreshButton, setRefreshButton] = useState(false);
  const [cellColor, setCellColor] = useState("rgb(25,118,210,0.15)");
  const [yearColor, setYearColor] = useState("");
  const [isExelButton, setIsExelButton] = React.useState<boolean>(true);

  // const [allAggregations, setAllAggregations] = useState<any>([]);
  // const [selectedAggregation, setSelectedAggregation] = useState<any>(totalDemand);

  //const [resetForm, setResetForm] = useState<boolean>(false);

  console.log("props", props);
  const resetData = () => {
    //setSelectedAggregation(totalDemand);
  };

  // const searchAggrData = (e: any) => {
  //   e.preventDefault();
  //   setResetForm(!resetForm);
  // //  getRows(year, year, 1, 12, selectedAggregation);
  // };

  // const getAllAggregations = () => {
  //   userDemand
  //     .getAggregations(props.tenant)
  //     .then((response: any) => {
  //       let currentAggr: any[] = [];
  //       response.map((aggr: String) => {
  //         currentAggr.push(convertMainTitle(aggr));
  //         //currentAggr.push(convertMainTitle(aggr));
  //       });
  //       setAllAggregations(currentAggr);
  //       setSelectedAggregation(totalDemand);
  //     })
  //     .catch((error: any) => {
  //       console.log("error", error);
  //     });
  // };

  // useMemo(() => {
  //   getAllAggregations();
  // }, []);

  // const [loading, setIsLoading] = useState<boolean>(false);

  let informationForAMonth;
  let dataCreateArray: any[] = [];
  let dataUpdateArray: any[] = [];
  let objectFormatingValues: any;

  const snackbar = useSnackbar();

  const currentDate = new Date();
  let currentMonth = currentDate.getMonth() + 1;
  let currentYear = currentDate.getFullYear();

  function isEditable(month: any) {
    return (
      isFutureMonth(month) && !(props.dataSearchFormOne === totalDemandUpper)
    );
  }

  function isFutureMonth(month: any) {
    if (year > currentYear) {
      return true;
    } else if (currentYear === year && month >= currentMonth) {
      return true;
    } else {
      return false;
    }
  }

  function currencyFormatter(params: any) {
    if (params.value) {
      if (params.id.includes("rfVsBgt") || params.id.includes("actualVsRF")) {
        return Number(params.value) + "%";
      }
    }
  }

  const getHeaderClassName = (month: number) => {
    return isFutureMonth(month) ? "futureClass" : "";
  };

  const getCellClassName = (month: any, subType: string) => {
    if (year < currentYear) {
      return subType === "Actual" ||
        subType === "Act vs Fcst" ||
        subType === "Budget" ||
        subType === "RF"
        ? "currYearBeforeEdit "
        : subType === "RF vs Budget"
        ? "borderBottomClass currYearBeforeEdit "
        : subType === "PRF"
        ? "PRFClass "
        : "currYearBeforeEdit";
    } else if (isFrozenYear && subType === "Budget" && isFutureMonth(month)) {
      return "currYearBeforeEditBudget";
    } else if (currentYear === year && !isFutureMonth(month)) {
      return subType === "Actual" || subType === "Act vs Fcst"
        ? "currYearBeforeEdit "
        : subType === "RF vs Budget"
        ? "borderBottomClass"
        : subType === "PRF"
        ? "PRFClass "
        : "currYearBeforeEdit";
    } else if (isFutureMonth(month)) {
      return subType === "PRF"
        ? "PRFEditableClass "
        : subType === "RF vs Budget"
        ? "futureClass borderBottomClass"
        : "futureClass";
    } else {
      return subType === "Budget" || subType === "RF"
        ? "budget-rf"
        : subType === "RF vs Budget"
        ? " borderBottomClass"
        : subType === "PRF"
        ? "PRFClass"
        : "past";
    }
  };

  const getCellClassNameFullYear = (month: any, subType: string) => {
    if (year < currentYear) {
      return subType === "Actual" ||
        subType === "Act vs Fcst" ||
        subType === "Budget" ||
        subType === "RF"
        ? "currYearBeforeEdit budget-rf"
        : subType === "RF vs Budget"
        ? "borderBottomClass currYearBeforeEdit budget-rf "
        : subType === "PRF"
        ? "PRFClass budget-rf PRFFullYearClass"
        : "currYearBeforeEdit budget-rf";
    } else {
      return subType === "Actual" || subType === "Act vs Fcst"
        ? "currYearBeforeEdit budget-rf"
        : subType === "RF vs Budget"
        ? "borderBottomClass budget-rf"
        : subType === "PRF"
        ? "PRFClass budget-rf PRFFullYearClass"
        : "currYearBeforeEdit budget-rf";
    }
  };

  const getRowClassName = (params: any) => {
    if (year > currentYear) {
      return params.row.subType === "Budget"
        ? "isEditableClassNextYearBudgetTop isEditableClassNextYearLeftRFBudget isEditableClassRFBudgetRight"
        : params.row.subType === "RF"
        ? "isEditableClassNextYearRFBottom isEditableClassNextYearLeftRFBudget isEditableClassRFBudgetRight"
        : "";
    } else if (year === currentYear) {
      switch (currentMonth) {
        case 1:
          return params.row.subType === "Budget"
            ? "isEditableClassCurrentYearBudgetTop isEditableClassRFBudgetRight monthJan"
            : params.row.subType === "RF"
            ? "isEditableClassCurrentYearRFBottom isEditableClassRFBudgetRight monthJan"
            : "";
        case 2:
          return params.row.subType === "Budget"
            ? "isEditableClassCurrentYearBudgetTop isEditableClassRFBudgetRight monthFeb"
            : params.row.subType === "RF"
            ? "isEditableClassCurrentYearRFBottom isEditableClassRFBudgetRight monthFeb"
            : "";
        case 3:
          return params.row.subType === "Budget"
            ? "isEditableClassCurrentYearBudgetTop isEditableClassRFBudgetRight monthMar"
            : params.row.subType === "RF"
            ? "isEditableClassCurrentYearRFBottom isEditableClassRFBudgetRight monthMar"
            : "";
        case 4:
          return params.row.subType === "Budget"
            ? "isEditableClassCurrentYearBudgetTop isEditableClassRFBudgetRight monthApr"
            : params.row.subType === "RF"
            ? "isEditableClassCurrentYearRFBottom isEditableClassRFBudgetRight monthApr"
            : "";
        case 5:
          return params.row.subType === "Budget"
            ? "isEditableClassCurrentYearBudgetTop isEditableClassRFBudgetRight monthMay"
            : params.row.subType === "RF"
            ? "isEditableClassCurrentYearRFBottom isEditableClassRFBudgetRight monthMay"
            : "";
        case 6:
          return params.row.subType === "Budget"
            ? "isEditableClassCurrentYearBudgetTop isEditableClassRFBudgetRight monthJun"
            : params.row.subType === "RF"
            ? "isEditableClassCurrentYearRFBottom isEditableClassRFBudgetRight monthJun"
            : "";
        case 7:
          return params.row.subType === "Budget"
            ? "isEditableClassCurrentYearBudgetTop isEditableClassRFBudgetRight monthJul"
            : params.row.subType === "RF"
            ? "isEditableClassCurrentYearRFBottom isEditableClassRFBudgetRight monthJul"
            : "";
        case 8:
          return params.row.subType === "Budget"
            ? "isEditableClassCurrentYearBudgetTop isEditableClassRFBudgetRight monthAug"
            : params.row.subType === "RF"
            ? "isEditableClassCurrentYearRFBottom isEditableClassRFBudgetRight monthAug"
            : "";
        case 9:
          return params.row.subType === "Budget"
            ? "isEditableClassCurrentYearBudgetTop isEditableClassRFBudgetRight monthSep"
            : params.row.subType === "RF"
            ? "isEditableClassCurrentYearRFBottom isEditableClassRFBudgetRight monthSep"
            : "";
        case 10:
          return params.row.subType === "Budget"
            ? "isEditableClassCurrentYearBudgetTop isEditableClassRFBudgetRight monthOct"
            : params.row.subType === "RF"
            ? "isEditableClassCurrentYearRFBottom isEditableClassRFBudgetRight monthOct"
            : "";
        case 11:
          return params.row.subType === "Budget"
            ? "isEditableClassCurrentYearBudgetTop isEditableClassRFBudgetRight monthNov"
            : params.row.subType === "RF"
            ? "isEditableClassCurrentYearRFBottom isEditableClassRFBudgetRight monthNov"
            : "";
        case 12:
          return params.row.subType === "Budget"
            ? "isEditableClassCurrentYearBudgetTop isEditableClassRFBudgetRight monthDec"
            : params.row.subType === "RF"
            ? "isEditableClassCurrentYearRFBottom isEditableClassRFBudgetRight monthDec"
            : "";

        default:
          break;
      }
    }
  };

  const checkNegativeInput = (params: GridPreProcessEditCellProps) => {
    const hasErrorNeg = params.props.value < 0;

    if (hasErrorNeg) {
      snackbar.show(
        "error",
        t("fleetPlanning.grossDemandDetermination.messages.negativeInput")
      );
    }

    const hasErrorMax = params.props.value > 9999999;

    if (hasErrorMax) {
      snackbar.show(
        "error",
        t("fleetPlanning.grossDemandDetermination.messages.tooHighInput")
      );
    }



    return { ...params.props, error: (hasErrorNeg || hasErrorMax) };
  };

  const tooltipForLabel = (subtype: string) => {
    
    if (subtype === 'PRF')
      return t("fleetPlanning.grossDemandDetermination.tooltip.prf");
    else if (subtype === 'RF')
      return t("fleetPlanning.grossDemandDetermination.tooltip.rf");
    else if (subtype === 'Act vs Fcst')
      return t("fleetPlanning.grossDemandDetermination.tooltip.actvsrf");
    else
      return subtype;

   
  };

  const labelForSubType = (subtype: string) => {
    
    if (subtype === 'PRF')
      return t("fleetPlanning.grossDemandDetermination.fields.prf");
    else if (subtype === 'Budget')
      return t("fleetPlanning.grossDemandDetermination.fields.budget");
    else if (subtype === 'RF')
      return t("fleetPlanning.grossDemandDetermination.fields.rf");
     else if (subtype === 'Actual')
      return t("fleetPlanning.grossDemandDetermination.fields.actual");
    else if (subtype === 'Act vs Fcst')
      return t("fleetPlanning.grossDemandDetermination.fields.actvsrf");
    else if (subtype === 'RF vs Budget')
      return t("fleetPlanning.grossDemandDetermination.fields.rfvsbudget");

  };

  const columns: GridColDef[] = [
    {
      field: "mainType",
      minWidth: 160,
      sortable: false,
      headerName: "",
      flex: 1,
      cellClassName: (params) => {
        return params.row.subType === "RF vs Budget"
          ? "mainTypeClass borderBottomClass"
          : "mainTypeClass";
      },
    },

    {
      field: "subType",
      minWidth: 140,
      sortable: false,
      headerName: "",
      flex: 1,
      cellClassName: (params) => {
        return params.row.subType === "PRF"
          ? "prfClass"
          : params.row.subType === "RF vs Budget"
          ? "borderBottomClass"
          : "";
      },
      renderCell: (params) => {
        return (
          <Tooltip title={tooltipForLabel(params.row.subType)}>             
              <span>{labelForSubType(params.value)}</span>
          </Tooltip>
        );
      }
    },

    {
      field: "1",
      headerName: t("fleetPlanning.months.janary"),
      sortable: false,
      valueFormatter: currencyFormatter,
      headerClassName: (params: any) => getHeaderClassName(params.field),
      editable: isEditable(1),
      flex: 1,
      type: "number", 
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) =>
        checkNegativeInput(params),
      cellClassName: (params) =>
        getCellClassName(params.field, params.row.subType),
    },

    {
      field: "2",
      headerName: t("fleetPlanning.months.february"),
      sortable: false,
      valueFormatter: currencyFormatter,
      headerClassName: (params: any) => getHeaderClassName(params.field),
      editable: isEditable(2),
      flex: 1,
      type: "number",
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) =>
        checkNegativeInput(params),
      cellClassName: (params) =>
        getCellClassName(params.field, params.row.subType),
    },
    {
      field: "3",
      headerName: t("fleetPlanning.months.march"),
      sortable: false,
      valueFormatter: currencyFormatter,
      headerClassName: (params: any) => getHeaderClassName(params.field),
      editable: isEditable(3),
      flex: 1,
      type: "number",
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) =>
        checkNegativeInput(params),
      cellClassName: (params) =>
        getCellClassName(params.field, params.row.subType),
    },
    {
      field: "4",
      headerName: t("fleetPlanning.months.april"),
      sortable: false,
      valueFormatter: currencyFormatter,
      headerClassName: (params: any) => getHeaderClassName(params.field),
      editable: isEditable(4),
      flex: 1,
      type: "number",
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) =>
        checkNegativeInput(params),
      cellClassName: (params) =>
        getCellClassName(params.field, params.row.subType),
    },
    {
      field: "5",
      headerName: t("fleetPlanning.months.may"),
      sortable: false,
      valueFormatter: currencyFormatter,
      headerClassName: (params: any) => getHeaderClassName(params.field),
      editable: isEditable(5),
      flex: 1,
      type: "number",
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) =>
        checkNegativeInput(params),
      cellClassName: (params) =>
        getCellClassName(params.field, params.row.subType),
    },
    {
      field: "6",
      headerName: t("fleetPlanning.months.june"),
      sortable: false,
      valueFormatter: currencyFormatter,
      headerClassName: (params: any) => getHeaderClassName(params.field),
      editable: isEditable(6),
      flex: 1,
      type: "number",
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) =>
        checkNegativeInput(params),
      cellClassName: (params) =>
        getCellClassName(params.field, params.row.subType),
    },
    {
      field: "7",
      headerName: t("fleetPlanning.months.july"),
      sortable: false,
      valueFormatter: currencyFormatter,
      headerClassName: (params: any) => getHeaderClassName(params.field),
      editable: isEditable(7),
      flex: 1,
      type: "number",
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) =>
        checkNegativeInput(params),
      cellClassName: (params) =>
        getCellClassName(params.field, params.row.subType),
    },
    {
      field: "8",
      headerName: t("fleetPlanning.months.august"),
      sortable: false,
      valueFormatter: currencyFormatter,
      headerClassName: (params: any) => getHeaderClassName(params.field),
      editable: isEditable(8),
      flex: 1,
      type: "number",
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) =>
        checkNegativeInput(params),
      cellClassName: (params) =>
        getCellClassName(params.field, params.row.subType),
    },
    {
      field: "9",
      headerName: t("fleetPlanning.months.september"),
      valueFormatter: currencyFormatter,
      sortable: false,
      headerClassName: (params: any) => getHeaderClassName(params.field),
      editable: isEditable(9),
      flex: 1,
      type: "number",
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) =>
        checkNegativeInput(params),
      cellClassName: (params) =>
        getCellClassName(params.field, params.row.subType),
    },
    {
      field: "10",
      headerName: t("fleetPlanning.months.october"),
      valueFormatter: currencyFormatter,
      sortable: false,
      headerClassName: (params: any) => getHeaderClassName(params.field),
      editable: isEditable(10),
      flex: 1,
      type: "number",
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) =>
        checkNegativeInput(params),
      cellClassName: (params) =>
        getCellClassName(params.field, params.row.subType),
    },
    {
      field: "11",
      headerName: t("fleetPlanning.months.november"),
      valueFormatter: currencyFormatter,
      sortable: false,
      headerClassName: (params: any) => getHeaderClassName(params.field),
      editable: isEditable(11),
      flex: 1,
      type: "number",
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) =>
        checkNegativeInput(params),
      cellClassName: (params) =>
        getCellClassName(params.field, params.row.subType),
    },
    {
      field: "12",
      headerName: t("fleetPlanning.months.december"),
      valueFormatter: currencyFormatter,
      sortable: false,
      headerClassName: (params: any) => getHeaderClassName(params.field),
      editable: isEditable(12),
      flex: 1,
      type: "number",
      preProcessEditCellProps: (params: GridPreProcessEditCellProps) =>
        checkNegativeInput(params),
      cellClassName: (params) =>
        getCellClassName(params.field, params.row.subType),
    },
    {
      field: "fullYear",
      valueFormatter: currencyFormatter,
      headerName: t("fleetPlanning.months.fullYear"),
      headerClassName: "budget-rf",
      sortable: false,
      flex: 1,
      type: "number",
      cellClassName: (params) =>
        getCellClassNameFullYear(params.field, params.row.subType),
    },
  ];

  const getRows = (
    yearTo: number,
    yearFrom: number,
    monthFrom: number,
    monthTo: number,
    aggregation: string
  ) => {
    setIsLoading(true);
    userDemand
      .getAll(tenant, yearTo, yearFrom, monthFrom, monthTo, aggregation)
      .then((r: any) => {
        setIsFrozenYear(r.frozenYear);
        setMappaResp(r);
        setRows(manageData(r));
        setIsLoading(false);
      })
      .catch((error: any) => {
        if (error.response) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: error.response.data.error,
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
          setMappaResp([]);
          setRows([]);
          setIsLoading(false);
        } else if (error.request) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("networkErrorMessage"),
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
          setMappaResp([]);
          setRows([]);
          setIsLoading(false);
        } else {
        }
        setIsLoading(false);
      });
  };

  function manageData(response: any) {
    if (response) {
      let channels = response.gddtPerChannel;

      let btDemand = props.dataSearchFormOne.toUpperCase();

      let rowsTable: any[] = [];
      let nameRowsTable: any[] = [];

      for (const element in channels) {
        if (element !== btDemand) {
          nameRowsTable.push(element);
        }
      }
      nameRowsTable.sort();
      nameRowsTable = nameRowsTable.concat(btDemand);

      for (const el of nameRowsTable) {
        rowsTable = rowsTable.concat(buildRow(channels[el]));
      }

      return rowsTable;
    }
  }

  function buildRow(elements: any) {
    let arrayChannel: any[] = new Array<any>();
    arrayChannel.push(buildDatas(elements, "budget"));
    arrayChannel.push(buildDatas(elements, "rf"));
    arrayChannel.push(buildDatas(elements, "rfProposal"));
    arrayChannel.push(buildDatas(elements, "actual"));
    arrayChannel.push(buildDatas(elements, "actualVsRF"));
    arrayChannel.push(buildDatas(elements, "rfVsBgt"));
    return arrayChannel;
  }

  function buildDatas(element: any, row: any) {
    let tableTempFinal: any = {};
    let tableTemp: any = { month: new Map<number, string>() };
    let arrayMonths: any[] = [];
    for (let index = 1; index <= 12; index++) {
      arrayMonths.push(index);
    }
    if (row === "rfProposal") {
      const mainType = element[0].channel;
      tableData.mainType = convertMainTitle(mainType);
    } else {
      tableData.mainType = "";
    }
    tableData.subType = convertSubTitle(row);

    arrayMonths.forEach((month: any, index: any) => {
      var objTemp = element.find((ele: any) => ele.month === month);
      if (objTemp) {
        if (objTemp.id === null || objTemp.id === undefined) {
          // if we have id null for month
          tableData.id = objTemp.month + "-" + row + "-" + objTemp.channel;
        } else {
          // if we have id null for full year
          tableData.id = objTemp.id + "-" + row + "-" + objTemp.channel;
        }
        if (objTemp[row]) {
          tableTemp.month.set(index + 1, objTemp[row].toString());
          objectFormatingValues = Object.fromEntries(tableTemp.month);
        } else {
          tableTemp.month.set(index + 1, objTemp[row]);
          objectFormatingValues = Object.fromEntries(tableTemp.month);
        }
      }
    });
    var objTempOne = element.find((ele: any) => !!ele.month === false);

    if (objTempOne[row] !== null) {
      tableData.fullYear = objTempOne[row].toString();
    } else {
      tableData.fullYear = objTempOne[row];
    }
    objectFormatingValues.subType = tableData.subType;
    objectFormatingValues.id = tableData.id;
    objectFormatingValues.fullYear = tableData.fullYear;
    objectFormatingValues.mainType = tableData.mainType;
    tableTemp.month = objectFormatingValues;

    tableTempFinal = tableTemp.month;
    return tableTempFinal;
  }

  function convertSubTitle(subTitle: any) {
    let subTitleString;
    switch (subTitle) {
      case "budget":
        return (subTitleString =
          subTitle.charAt(0).toUpperCase() + subTitle.slice(1));

      case "rf":
        return (subTitleString = subTitle.toUpperCase());
      case "rfProposal":
        return (subTitleString = "PRF");
      case "actual":
        return (subTitleString = "Actual");
      case "actualVsRF":
        return (subTitleString = "Act vs Fcst");
      case "rfVsBgt":
        return (subTitleString = "RF vs Budget");
    }
  }

  function convertMainTitle(mainType: any) {
    let mainTitleString = "";
    function titleCase(str: any) {
      var splitStr = str.toLowerCase().split(" ");
      for (var i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      mainTitleString = splitStr.join(" ");
      return mainTitleString;
    }
    titleCase(mainType);
    switch (mainType) {
      case "":
        return (mainTitleString = "");
      default:
        return mainTitleString;
    }
  }

  function cancel() {
    props.setRefreshButton(!props.refreshButton);
  }

  const handleOnCellEditCommit = (params: any) => {
    if (!Number(params.value)) {
      dispatchGlobalData({
        type: setSnackbar,
        payload: {
          snackbar: {
            message: t("fleetPlanning.messages.validNumber"),
            type: snackbarTypes.error,
            show: true,
            autoClose: true,
          },
        },
      });
    } else {
      let strSplitID = params?.id?.split("-");
      let arrElement = mappaResp.gddtPerChannel[strSplitID[2]];
      informationForAMonth = arrElement.find(
        (e: any) => e.month === Number(params?.field)
      );
      const values = params.id.includes("budget") ? "budget" : "rf";
      if (informationForAMonth.id) {
        const newUpdatedObject = {
          id: informationForAMonth.id,
          channelId: informationForAMonth?.channelId,
          [values]: Number(params.value),
        };
        dataUpdateArray.push(newUpdatedObject);
      } else {
        const newCreateObject = {
          id: informationForAMonth?.id,
          month: informationForAMonth?.month,
          year: informationForAMonth?.year,
          channel: informationForAMonth?.channel,
          channelId: informationForAMonth?.channelId,
          [values]: Number(params.value),
        };
        dataCreateArray.push(newCreateObject);
      }
    }
  };

  useEffect(() => {
    setIsLoading(true);
    if (year > new Date().getFullYear()) {
      setYearColor("#00A0DF");
      setCellColor("rgba(0, 160, 223, 0.1)");
    } else if (year < new Date().getFullYear()) {
      setYearColor("#C8017D");
      setCellColor("rgba(255, 255, 255, 1)");
    } else {
      setYearColor("#011E41");
      setCellColor("rgb(1, 30, 65, 0.1)");
    }
    if (props.dataSearchFormOne) {
      getRows(year, year, 1, 12, props.dataSearchFormOne);
    }
  }, [year, isFrozenYear, props.refreshButton, props.dataSearchFormOne]);

  async function updateTable() {
    setIsLoading(true);
    if (dataCreateArray.length) {
      createDetermination();
      // setRefreshButton(!refreshButton);
    }
    if (dataUpdateArray.length) {
      updateDetermination();
      // setRefreshButton(!refreshButton);
    }

    setIsLoading(false);
  }

  async function createDetermination() {
    const mergeDataCreate = dataCreateArray.reduce((prev, item) => {
      const index = prev.findIndex(
        (v: any) => v.month === item.month && v.channel === item.channel
      );
      if (index === -1) {
        prev.push(item);
      } else {
        prev[index] = { ...prev[index], ...item };
      }
      return prev;
    }, []);
    await userDemand
      .create(tenant, mergeDataCreate)
      .then((request: any) => {})
      .catch((error: any) => {
        if (error.response) {
          if (error.response.status === 400) {
            dispatchGlobalData({
              type: setSnackbar,
              payload: {
                snackbar: {
                  message: t(
                    "fleetPlanning.grossDemandDetermination.messageForBadRequest"
                  ),
                  type: snackbarTypes.error,
                  show: true,
                  autoClose: true,
                },
              },
            });
            setMappaResp([]);
            setRows([]);
            setIsLoading(false);
          } else {
            dispatchGlobalData({
              type: setSnackbar,
              payload: {
                snackbar: {
                  message: error.response.data.error,
                  type: snackbarTypes.error,
                  show: true,
                  autoClose: true,
                },
              },
            });
            setMappaResp([]);
            setRows([]);
            setIsLoading(false);
          }
        } else if (error.request) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("networkErrorMessage"),
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
          setMappaResp([]);
          setRows([]);
          setIsLoading(false);
        } else {
        }
        setIsLoading(false);
      });

    dataCreateArray = [];
    props.setRefreshButton(!props.refreshButton);
  }

  async function updateDetermination() {
    const mergeDataUpdate = dataUpdateArray.reduce((prev, item) => {
      const index = prev.findIndex((v: any) => v.id === item.id);
      if (index === -1) {
        prev.push(item);
      } else {
        prev[index] = { ...prev[index], ...item };
      }
      return prev;
    }, []);

    await userDemand
      .update(tenant, mergeDataUpdate)
      .then((request: any) => {})
      .catch((error: any) => {
        if (error.response) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: error.response.data.error,
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
          setMappaResp([]);
          setRows([]);
          setIsLoading(false);
        } else if (error.request) {
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("networkErrorMessage"),
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
          setMappaResp([]);
          setRows([]);
          setIsLoading(false);
        } else {
        }
        setIsLoading(false);
      });
    dataUpdateArray = [];
    props.setRefreshButton(!props.refreshButton);
  }

  return (
    <Box component="div">
      <Box>
        {/* <form id="idAggrForm" onSubmit={(event) => searchAggrData(event)}>
          <GenericFilterBox
            formId="idAggrForm"
            onReset={resetData}
            showExtrasFilters={false}
          >
            
              <Autocomplete
                    disablePortal
                    disableClearable
                    id="aggregation"
                    value={selectedAggregation}
                    options={allAggregations.map((response:any) =>  response)}
                    getOptionLabel={(option) => option}
                    onChange={(e, value) => setSelectedAggregation(value)}
                    renderInput={(params:any) => <TextField fullWidth variant="standard"

                    {...params} label={t("fleetPlanning.grossDemandDetermination.aggregation")} />}
                  />
            
            <Box>&nbsp;</Box>              
            <Box>&nbsp;</Box>
          </GenericFilterBox>
        </form> */}
      </Box>
      <Box
        component="div"
        className="boxTableFirst"
        sx={{
          "& .mainTypeClass": {
            whiteSpace: "pre-line !important",
            backgroundColor: "rgb(245,245,245)",
            fontWeight: "700 !important",
            borderBottom: "none !important",
            alignItems: "left",
            //paddingBottom: "5px",
          },

          "& .futureClass": {
            backgroundColor: cellColor,
          },
          "& .PRFClass": {
            backgroundColor: "rgba(245, 245, 245, 1)",
            color: "rgba(0, 0, 0, 0.3)",
            //opacity: '30%'
          },
          "& .budget-rf ": {
            backgroundColor: "rgb(245,245,245)",
            // opacity: '30%'
          },

          "& .prfClass ": {
            backgroundColor: "rgba(245, 245, 245, 1)",
          },
          "& .currYearBeforeEdit ": {
            color: "rgba(0, 0, 0, 0.3)",
          },

          "& .currYearBeforeEditBudget ": {
            color: "rgba(0, 0, 0, 0.3)",
            borderTop: "2px  solid  " + yearColor + " !important",
          },


          "& .PRFFullYearClass": {
            backgroundColor: "rgb(222,222,226)",
          },

          "& .borderBottomClass": {
            borderBottom: "2px  solid " + yearColor + "!important",
            //opacity: '30%'
          },
          "& .PRFEditableClass": {
            backgroundColor: "rgba(1, 30, 65, 0.1) !important",
            boxShadow: "rgba(0, 160, 223, 0.1)",
            fill: "solid rgba(0, 160, 223, 0.1)",
            color: "rgba(0, 0, 0, 0.3)",
          },
          "& .isEditableClass": {
            borderBottom: "2px  solid  #cecdcd !important",
          },
          "& .MuiDataGrid-cell": {
            textOverflow: "clip",
          },

          "& .MuiDataGrid-columnSeparator": {
            display: "none !important",
          },
          "& .MuiDataGrid-root": {
            backgroundColor: "white",
            fontSize: "12px",
            //lineHeight:"1"
          },

          "& .isEditableClassNextYearRFBottom": {
            " &>:nth-of-type(n+3):nth-of-type(-n+14)": {
              borderBottom: "2px  solid " + yearColor,
            },
          },

          "& .isEditableClassNextYearLeftRFBudget": {
            " &>:nth-of-type(3)": { borderLeft: "2px  solid " + yearColor },
          },
          "& .isEditableClassRFBudgetRight": {
            " &>:nth-of-type(14)": { borderRight: "2px  solid " + yearColor },
          },
          "& .isEditableClassNextYearBudgetTop": {
            " &>:nth-of-type(n+3):nth-of-type(-n+14)": {
              borderTop: "2px  solid " + yearColor,
            },
          },

          "& .isEditableClassCurrentYearRFBottom": {
            "& .futureClass": {
              borderBottom: "2px  solid " + yearColor,
            },
          },

          "& .isEditableClassCurrentYearBudgetTop": {
            "& .futureClass": {
              borderTop: "2px  solid " + yearColor,
            },
          },
          "& .monthJan ": {
            " &>:nth-of-type(3)": { borderLeft: "2px  solid " + yearColor },
          },
          "& .monthFeb": {
            " &>:nth-of-type(4)": { borderLeft: "2px  solid " + yearColor },
          },
          "& .monthMar": {
            " &>:nth-of-type(5)": { borderLeft: "2px  solid " + yearColor },
          },
          "& .monthApr": {
            " &>:nth-of-type(6)": { borderLeft: "2px  solid " + yearColor },
          },
          "& .monthMay": {
            " &>:nth-of-type(7)": { borderLeft: "2px  solid " + yearColor },
          },
          "& .monthJun": {
            " &>:nth-of-type(8)": { borderLeft: "2px  solid " + yearColor },
          },
          "& .monthJul": {
            " &>:nth-of-type(9)": { borderLeft: "2px  solid " + yearColor },
          },
          "& .monthAug": {
            " &>:nth-of-type(10)": { borderLeft: "2px  solid " + yearColor },
          },
          "& .monthSep": {
            " &>:nth-of-type(11)": { borderLeft: "2px  solid " + yearColor },
          },
          "& .monthOct": {
            " &>:nth-of-type(12)": { borderLeft: "2px  solid " + yearColor },
          },
          "& .monthNov": {
            " &>:nth-of-type(13)": { borderLeft: "2px  solid " + yearColor },
          },
          "& .monthDec": {
            " &>:nth-of-type(14)": { borderLeft: "2px  solid " + yearColor },
          },

          "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus , & .MuiDataGrid-cell--editable":
            {
              outline: "none !important",
            },

          "& .MuiDataGrid-columnHeader": {
            fontSize: "12px",
            lineHeight: "20px",
            fontFamily: "Raleway",
            color: "#757575",
            backgroundColor: "rgb(255,255, 255, 1)",
            fontStyle: "normal",
          },
        }}
      >
        <DataGrid
          isCellEditable={(params: any) =>
            (params.row.subType === "Budget" &&
              !params.row?.id.includes(props.dataSearchFormOne.toUpperCase()) &&
              isFrozenYear === false || isFrozenYear === undefined || isFrozenYear === null) ||
            (!params.row?.id.includes(props.dataSearchFormOne.toUpperCase()) &&
              params.row.subType === "RF")
          }
          columns={columns}
          rowHeight={30}
          headerHeight={50}
          getRowClassName={getRowClassName}
          autoHeight
          {...rows}
          disableColumnMenu
          rows={rows}
          onCellEditCommit={handleOnCellEditCommit}
          disableSelectionOnClick
          components={{
            Toolbar: FleetPlanningToolbar,
            Footer: FleetPlanningFooter,
          }}
          componentsProps={{
            toolbar: {
              rows,
              year,
              yearColor,
              isFrozenYear,
              setIsFrozenYear,
              isExelButton,
              exportUrl,
            },
            footer: { year, setYear, yearColor },
          }}
        />
        {year >= currentYear &&
          (hasScope("SCOPE_CREATE_GDD_PLANNING") ||
            hasScope("SCOPE_UPDATE_GDD_PLANNING")) && (
            <Box
              sx={{
                justifyContent: "flex-end",
                display: "flex",
                paddingTop: "10px",
              }}
            >
              <Mui.Grid container spacing={2} justifyContent="end">
                <Mui.Grid item xs={6} sm={3} lg={1.1}>

                <Mui.Button variant="outlined" onClick={cancel} fullWidth >
                      <Mui.Typography variant="h6" color={'accent'}>
                      {t("actionButtons.cancel")}
                      </Mui.Typography>
                  </Mui.Button>

                </Mui.Grid>

                <Mui.Grid item xs={6} sm={3} lg={1.15}>

                <Mui.Button onClick={updateTable} fullWidth >
                      <Mui.Typography variant="h6" color={'accent'}>
                      {t("actionButtons.save")}
                      </Mui.Typography>
                  </Mui.Button>
                </Mui.Grid>
              </Mui.Grid>

            </Box>
          )}
        {loading && <CustomLoader loading={loading} />}
      </Box>
    </Box>
  );
};

export default GrossDemandDeterminationTable;
